import React, { useEffect } from 'react'
import { gql } from '@/__generated__'
import { useQuery as useAppoloQuery } from '@apollo/client'
import { useQuery } from '@tanstack/react-query'
import { create } from 'zustand'
import { useTRPCClient } from '@/api/trpc/context'
import { useLocalStorage } from 'usehooks-ts'

interface SystemContextProps {
  lastUpdate: Date
  isUpToDate: boolean
  blockchainTimeDiff: number
  block: number
  getCurrentDateTime: () => Date
}

export const useSystem = create<SystemContextProps>((_, get) => ({
  lastUpdate: new Date(),
  isUpToDate: true,
  blockchainTimeDiff: 0,
  block: 0,
  currentDateTime: new Date(),
  getCurrentDateTime: () => new Date(new Date().getTime() + get().blockchainTimeDiff || 0),
}))

const metadataQuery = gql(`
  query ReadMetadata {
    metadata
  }
`)

export const SystemProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data } = useAppoloQuery(metadataQuery, {
    pollInterval: 5000,
  })

  useEffect(() => {
    if (data) {
      useSystem.setState({
        isUpToDate: !data.metadata.catching_up,
        block: data.metadata.block,
        blockchainTimeDiff: data.metadata.server_time - new Date().getTime(),
        lastUpdate: new Date(),
      })
    }
  }, [data])

  const [value] = useLocalStorage<any>('account', undefined)

  useQuery({
    queryFn: async () => {
      if (value) {
        const t = useTRPCClient()
        await t.private.ping.ping.mutate()
      }

      return null
    },
    queryKey: ['ping', value?.privateKey_expiry],
    refetchInterval: 60_000,
  })

  return children
}
